howspace.components.tab = (() => {
    'use strict';

    const showTabPanel = (tab) => {
        const isSelected = tab.attr('aria-selected') === 'true';

        if (isSelected) {
            // Tab is already selected.
            return;
        }

        // Unselect currently selected tab and collapse its panel.
        const selectedTab = tab.closest('.howspace-tabs').find('[role="tab"][aria-selected="true"]');
        if (selectedTab.attr('aria-controls')) {
            const selectedTabPanel = $('#' + selectedTab.attr('aria-controls'));
            real.infiniteScroll.pause(selectedTabPanel.find('.real-infinite-scroll-initialized'));
            selectedTab.attr('aria-selected', 'false');
            selectedTabPanel.removeClass('expanded').addClass('collapsed');
            howspace.dispatchEvent(selectedTabPanel, howspace.components.tab.TAB_HIDDEN);
        }

        if (tab.attr('aria-controls')) {
            // Select this tab and expand its content.
            const tabPanel = $('#' + tab.attr('aria-controls'));
            tab.attr('aria-selected', 'true');
            tabPanel.removeClass('collapsed').addClass('expanded');
            real.infiniteScroll.resume(tabPanel.find('.real-infinite-scroll-initialized'));
            howspace.dispatchEvent(tabPanel, howspace.components.tab.TAB_SHOWN, {
                tab: tab
            });
        }
    };

    const handleClick = (e) => {
        showTabPanel($(e.target).closest('[role="tab"]'));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            // Enter or Space keypress on card title.
            // https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
            e.preventDefault();
            showTabPanel($(e.target));
        }
    };

    return {
        TAB_SHOWN : 'howspace-tabs-tab-shown',
        TAB_HIDDEN : 'howspace-tabs-tab-hidden',
        init : (elem) => {
            elem.findIncludingSelf('.howspace-tabs:not(.howspace-tabs-initialized)').each(function() {
                const tabs = $(this);
                tabs.addClass('howspace-tabs-initialized');
                tabs.on('click', '[role="tab"]', handleClick);
                tabs.on('keypress', '[role="tab"]', handleKeyPress);
                if (tabs.find('.howspace-tab .step').length > 0) {
                    tabs.addClass('has-steps');
                }
            });
        },
        destroy : (elem) => {
            elem.findIncludingSelf('.howspace-tabs.howspace-tabs-initialized').each(function() {
                const tabs = $(this);
                tabs.removeClass('howspace-tabs-initialized');
                tabs.off('click', '[role="tab"]', handleClick);
                tabs.off('keypress', '[role="tab"]', handleKeyPress);
            });
        }
    };

})();
